// External library imports
import React, { FC, useMemo } from 'react';
import clsx from 'clsx';

// Internal library imports
import { RichText } from '@marriott/mi-ui-library';

import { CardArtBadgeProps } from './CardArtBadge.types';
import { StyledCardArtBadge } from './CardArtBadge.styles';
import { CobrandImage } from '../CobrandImage/CobrandImage';

/**
 * CardArtBadge component displays a card image with an optional promotional badge overlay
 * Used in vertical card layouts to highlight special offers
 */
export const CardArtBadge: FC<CardArtBadgeProps> = ({
  badgeDetails,
  imagePath,
  customClass,
  defaultImageText,
  imageClass,
  badgeClass,
  addSpaceToCardArt,
  displayCardArtBadge,
}) => {
  // Determine if badge should be shown
  const shouldShowBadge = useMemo(
    () => badgeDetails && displayCardArtBadge?.toString() === 'true',
    [badgeDetails, displayCardArtBadge]
  );

  return (
    <StyledCardArtBadge data-component-name="m-cobrand-CardArtBadge" data-testid="cobrand-CardArtBadge">
      <div className={clsx('d-flex flex-column align-items-center justify-content-center', customClass)}>
        {/* Promotional badge overlay (e.g., "OUR BEST OFFER") */}
        {shouldShowBadge && badgeDetails && (
          <div>
            <RichText
              customClass={clsx('t-font-xs m-badge-overlay-merch badge-border-style mx-2', badgeClass)}
              text={badgeDetails}
              componentId="card-art-badge"
            />
          </div>
        )}

        {/* Card image with conditional top margin */}
        <div className={clsx('text-center img-full-width', addSpaceToCardArt === 'true' && 'mt-4')}>
          <CobrandImage
            defaultImageURL={imagePath}
            altText={defaultImageText || 'Card image'}
            customClass={imageClass}
          />
        </div>
      </div>
    </StyledCardArtBadge>
  );
};
